import { render, staticRenderFns } from "./NewEventDetailsCard.vue?vue&type=template&id=98e33cb2"
import script from "./NewEventDetailsCard.vue?vue&type=script&lang=js"
export * from "./NewEventDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports